// export const API_ROOT_URL = 'https://stag2.imagine.io';
export const API_ROOT_URL = 'https://prod.imagine.io';

export const GET_SCENE_LABEL_PUBLIC_API = '/configurator/api/sceneoption-public-data/';
export const GET_LABEL_OPTIONS_PUBLIC_API = '/configurator/api/scenetexture-public-data/';
export const GET_PROTOTYPE_PREVIEWS_API = '/configurator/api/update-scene-texture-render/';

// render & preview//
export const GET_RENDER_PREVIEW = '/rendering-system/api/v3/project-render-images/';
export const GET_DOWNLOAD_RENDER_IMAGES = '/rendering-system/api/v3/lambda/download-renders/';
export const GET_RENDER_DATA = '/rendering-system/api/v3/get-render/';
export const RENDER_PARTIAL_PAYMENT = '/rendering-system/api/v3/render-partial-payment-detail/';

export const GET_RENDER_STORE_LIST = '/configurator/api/get-render-store/';
export const REORDER_VIEWS = '/configurator/api/multiple-sceneview-seq-update/';
export const CONFIG_PUBLIC_LINK = 'configurator/api/config-public-link/';
export const CONFIG_PUBLIC_DATA = 'configurator/api/config-public-data/';
// export const CONFIG_PUBLIC_DATA_V2 = 'configurator/api/v2/config-public-data/';
export const GET_LABEL_OPTIONS_API = '/configurator/api/scene-texture/';
export const GET_SCENE_PUBLIC_DATA = '/configurator/api/all-scene-public-data/';
export const CHECK_FOR_UNICODE = '';
